import $ = require('jquery');
import ko = require('knockout');

import "knockout.validation";
import "jquery.inputMask";
import 'foundation';
import 'foundation-topbar';
import "foundation-offcanvas";
import 'SharedComponents';
import "jquery.parseJSONWithDates";
import "inputMask";
import "Utils/ViewModelTemplateLoader";
import "moment";

class PublicViewModel {
    pageTitle: KnockoutObservable<string>;

    private defaultPageTitle: string = 'WoundExpert';

    constructor() {
        this.pageTitle = ko.observable(this.defaultPageTitle);
    }
}

var publicViewModel = new PublicViewModel();


$.ajaxSetup({
    converters: {
        "text json_with_dates": function(text) {
            return (<any>$).parseJSONWithDates(text);
        }
    }
});

$(document).foundation();

ko.validation.init({
    registerExtenders: true,
    messagesOnModified: true,
    insertMessages: true,
    parseInputAttributes: true,
    messageTemplate: null,
    errorMessageClass: 'error'
}, true);

Promise.config({ cancellation: true, warnings: false, longStackTraces: false })

ko.applyBindings(publicViewModel, document.getElementsByTagName('html')[0]);
